module.exports = __webpack_public_path__ + "static/media/introScreenIcon@3x.46d47c51.png";